<template>
  <div class="address-list">
    <!-- Add new address link -->
    <a @click="openForm" href="#" class="add-new-address">+ Add a new address</a>

    <div class="address-cards">
      <div
        v-for="(address, index) in addressListPinia"
        :key="index"
        :class="['address-card', address.is_default ? 'default-address' : '']"
        @click="()=>selectAddress(address)"
        >
        <!-- :class="['address-card', address.is_default ? 'default-address' : '']" -->
        <!-- @click="()=>selectAddress(address)" -->
        <p>
          {{ address?.address1 }}, {{ address?.address2 }}<br />
          {{ address?.landmark }}<br />
          {{ address?.city }}, {{ address?.state }} - {{ address?.pincode }}<br />
          {{ address?.phone }}
        </p>
        <!-- Action buttons -->
        <div class="action-buttons">
          <button @click="editAddress($event,address)"><i class="fa fa-pencil"></i></button>
          <button @click="deleteAddress($event,address.id)"><i class="fa fa-trash"></i></button>
        </div>
      </div>
      <div class="text-center" v-if="addressList.length == 0">No items in the list</div>
    </div>
  </div>
</template>

<script>
import { useUserStore } from '@/stores/userStore';
import useAuthenticatedApi from '@/plugins/useAuthenticatedApi';
import eventBus from '@/utils/eventBus';
import { useCartStore } from '@/stores/cart';
import { computed } from 'vue';
const userStore = useUserStore();
export default {
  data() {
    return {
      newForm: false,
      addressList: [],
      selected_address: null,
    };
  },
  props:{
    onLogin:{
      type:Boolean,
      default:false
    },
  },
  mounted(){
    this.fetchAddressList()
  },
  methods:{
    async openForm () {
      if(eventBus?.panelOpen){
        eventBus.panelOpen("Address Details")
      }
    },
    async fetchAddressList(){
      if(this.isLoggedIn){
        const { addressService } = useAuthenticatedApi();
        const result = await addressService.getAddressList();
        this.addressList = result.data;
        userStore.setAddressList(result.data);
      }
    },
    async deleteAddress(event,id){
      event.preventDefault();
      event.stopPropagation();
      if(confirm("Are you sure you want to delete this address?")) {
        const { addressService } = useAuthenticatedApi();
        await addressService.deleteAddressItem(id);
        this.fetchAddressList(); // Refresh the list after deletion
      }
    },
    editAddress(event,address){
      event.stopPropagation();
      event.preventDefault();
      if(eventBus?.panelOpen){
        eventBus.panelOpen("Address Details",{address})
      }
    },
    async selectAddress(address){
      if(!this.$props.onLogin){

        if(confirm("Some items may not be available in this address, Are You Sure?")) {
          userStore.setShippingAddress(address);
          if(eventBus.panelClose){
            eventBus.panelClose()
          }
        }
      }else{
        console.log(address);
        userStore.setShippingAddress(address);
          if(eventBus.panelClose){
            eventBus.panelClose()
          }
          
        }
        const cartStore = useCartStore();
        cartStore.updateCartActions(useUserStore().getmca_no,true);

        // Check if productQueue has items
        if (userStore.productQueue?.length > 0) {
          console.log("Processing items in productQueue:", userStore.productQueue);

          for (const queuedProduct of userStore.productQueue) {
            const { product, isFreeItem, isAddedItem } = queuedProduct;
          
            // Call addToCart from the cart store
            try {
              await cartStore.addToCart(product, isFreeItem, isAddedItem);
              console.log("Added product to cart from queue:", product);
            } catch (error) {
              console.error("Failed to add product to cart from queue:", product, error);
            }
          }
        
          // Clear the productQueue after processing
          userStore.clearProductQueue();
          console.log("Cleared productQueue after processing.");
        }
    }
  },
  setup(){
  const addressListPinia = computed(()=>userStore.addressList);
  return {addressListPinia }
  },
  computed: {
    isLoggedIn(){
      return userStore.isLoggedIn;
    },
  },
};
</script>
<style lang="css" scoped>
.action-buttons {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: 10px;
}

.action-buttons button {
  background-color: transparent ;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 14px;
}

.action-buttons button:hover {
  /* background-color: #d3d3d3; */
}

.action-buttons button:first-child {
  /* background-color: #4CAF50; */
  /* color: white; */
}

.action-buttons button:last-child {
  /* background-color: #f44336; */
  /* color: white; */
}

.address-card{
  text-align: start;
  display: flex;
}

h2 {
  font-size: 24px;
  font-weight: bold;
}

.search-bar {
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #000;
  border-radius: 4px;
}

.search-bar input {
  border: none;
  flex: 1;
  font-size: 14px;
  padding: 5px;
}

.search-bar .search-btn {
  background: none;
  border: none;
  cursor: pointer;
}

.search-icon {
  background-size: cover;
  width: 20px;
  height: 20px;
  display: inline-block;
}

.add-new-address {
  display: inline-block;
  margin-bottom: 20px;
  font-size: 14px;
  /* color: #000; */
  text-decoration: none !important;
  text-align: right;
  width: 100%;
}

.add-new-address:hover {
  text-decoration: underline;
}

.address-cards {
  display: flex;
  flex-direction: column;
}

.address-card:hover {
  background-color: #276ca5;
  color: #fff;
}
.address-card {
  padding: 15px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
}

.address-card.default-address {
  background-color:#276ca5;
  /* background-color:#05354d; */
  color: white !important;
  /* border-color: ; */
}

.address-card p {
  margin: 5px 0;
  font-size: 14px;
  width: 100%;
}

</style>